import React from "react";
import "./Settings.scss";
import dashboardIcon from "../../images/settings-dashboard.svg";
import programIcon from "../../images/settings-program.svg";
import CRMIcon from "../../images/settings-crm.svg";
import reportingIcon from "../../images/settings-reporting.svg";
import marketingIcon from "../../images/settings-marketing.svg";
import batchIcon from "../../images/settings-batch.svg";
import settingsIcon from "../../images/settings-settings.svg";
import helpcenterIcon from "../../images/settings-helpcenter.svg";
import seucrity from "../../images/shield-search.svg";
import marketPlace from "../../images/home-hashtag.svg";
import collaborate from "../../images/profile-2user.svg";
import loansIcon from "../../images/loans.svg";
import { Link } from "react-router-dom";
import { Box, Typography, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { USER_LOANS_UI_ENABLED } from "../../features/userLoans";

function Settings() {
  //loop through the setting options to add it to the list of settings
  //will need to add url to the link to navigate to the correct page
  let configVariables = useSelector((state) => state.config.baseConfig);

  const decodeHTML = (str) => {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
};


const raw = configVariables.portalMiniApps;
const raw2 = configVariables.portalMiniApps2;
let isDevEnv = configVariables.devEnvironment;

const decoded = decodeHTML(raw);
const decoded2 = decodeHTML(raw2);
 const miniApps = JSON.parse(decoded);
 const miniApps2 = JSON.parse(decoded2);

 console.log("miniApps", miniApps);
 console.log("miniApps2", miniApps2); // { dashboard: true }

  // console.log("config value check",configVariables.portalMiniApps);
  // console.log("config value parse check",JSON.parse(configVariables.portalMiniApps));


  // const settingOptions = [
  //   // {
  //   //   icon: dashboardIcon,
  //   //   option: "Dashboard",
  //   //   description: "Billing, security, audit log, adn other account essentials",
  //   //   link: "/dashboard",
  //   //   show: miniApps.dashboard || miniApps2.dashboard,
  //   // },
  //   // {
  //   //   icon: programIcon,
  //   //   option: "Licenses",
  //   //   description:
  //   //     "Team management, user and organization fields, bulk actions, and tags",
  //   //   link: "/dashboard",
  //   //   show: miniApps.licenses || miniApps2.licenses,
  //   // },
  //   {
  //     icon: CRMIcon,
  //     option: "CRM",
  //     description:
  //       "Ways to connect with customers, from email and Talk to messaging and Flow Builder",
  //     link: "/crm",
  //     show: miniApps.crm || miniApps2.crm,
  //   },
  //   {
  //     icon: reportingIcon,
  //     option: "Reporting",
  //     description:
  //       "Managing how team members use Zendesk, from views and macros to Agent Workspace",
  //     link: "/reporting",
  //     show: miniApps.reporting || miniApps2.reporting,
  //   },
  //   // {
  //   //   icon: marketingIcon,
  //   //   option: "Marketing",
  //   //   description: "Ticket fields, triggers, automations, and more",
  //   //   link: "/dashboard",
  //   //   show: miniApps.marketing || miniApps2.marketing,
  //   // },
  //   // {
  //   //   icon: batchIcon,
  //   //   option: "Batch Services",
  //   //   description:
  //   //     "Apps, APIs, targets, webhooks, and other ways to get data in and out of Zendesk",
  //   //   link: "/batch",
  //   //   show: miniApps.batchServices || miniApps2.batchServices,
  //   // },
  //   // // {
  //   // //   icon: settingsIcon,
  //   // //   option: "Settings",
  //   // //   description: "Tips and answers to your questions about Admin Center",
  //   // // },
  //   // {
  //   //   icon: helpcenterIcon,
  //   //   option: "Business Rules",
  //   //   description: "Tips and answers to your questions about Admin Center",
  //   //   link: "/dashboard",
  //   //   show: miniApps.businessRules || miniApps2.businessRules,
  //   // },
  //   // {
  //   //   icon: seucrity,
  //   //   option: "Security",
  //   //   description: "Tips and answers to your questions about Admin Center",
  //   //   link: "/dashboard",
  //   //   show: miniApps.security || miniApps2.security,
  //   // },
  //   // {
  //   //   icon: settingsIcon,
  //   //   option: "Help Center",
  //   //   description: "Tips and answers to your questions about Admin Center",
  //   //   link: "/dashboard",
  //   //   show: miniApps.helpCenter || miniApps2.helpCenter,
  //   // },
  //   // {
  //   //   icon: marketPlace,
  //   //   option: "Marketplace",
  //   //   description:
  //   //     "Quickly manage modules in your CBS to extend new capabilities and services.",
  //   //   link: "/marketplace",
  //   //   show: miniApps.marketplace || miniApps2.marketplace,
  //   // },
  //   // {
  //   //   icon: collaborate,
  //   //   option: "Collaborate (CoFi) Lab",
  //   //   description:
  //   //     "Transforming the financial services landscape through Collaborative Finance (CoFi). Connect with forward-thinking businesses ready to collaborate.",
  //   //   link: "/cofilab",
  //   //   show: miniApps.collaborate || miniApps2.collaborate,
  //   // },
  //   // {
  //   //   icon: collaborate,
  //   //   option: "CS DEMO (Credit Scoring)",
  //   //   description:
  //   //     "A comprehensive tool for managing customer data, processing loan applications, and overseeing loan repayments",
  //   //   link: "/credit-scoring",
  //   //   show: miniApps.csDemo || miniApps2.csDemo,
  //   // },
  //   //   {
  //   //     icon: collaborate,
  //   //     option: "Loan Setup",
  //   //     description:
  //   //       "A comprehensive tool for managing loans",
  //   //     link: "/loansetup",
  //   //     show: miniApps.loanSetup || miniApps2.loanSetup,
  //   //   },
  //   //   {
  //   //     icon: collaborate,
  //   //     option: "Loan Rule Setup",
  //   //     description:
  //   //       "Configure eligibility rules, interest rates, tenures, fees, and approval criteria for loan products",
  //   //     link: "/loan-rule-setup",
  //   //     show: miniApps.loanRuleSetup || miniApps2.loanRuleSetup,
  //   //   },
  //   //   {
  //   //     icon: collaborate,
  //   //     option: "Loan Reports",
  //   //     description:
  //   //       "A comprehensive tool for viewing loan reports",
  //   //     link: "/loanreports",
  //   //     show: miniApps.loanReports || miniApps2.loanReports,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Early Warning Service",
  //   //     description:
  //   //       "Monitor portfolio credit scores, repayment risk, overdue exposure, ageing, and medium or high-risk loan accounts.",
  //   //     link: "/loans/early-warning",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Loan Enquiry Management",
  //   //     description:
  //   //       "Capture prospective borrower enquiries, run eligibility screening, manage borderline reviews, documents, quotations and screening policies.",
  //   //     link: "/loans/enquiries",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Loan Application Management",
  //   //     description:
  //   //       "Manage formal application cases from submission and underwriting through approval, sanction or rejection.",
  //   //     link: "/loans/applications",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Loan Disbursements",
  //   //     description:
  //   //       "Manage portfolio-wide disbursement approvals, release readiness, completed funding and operational exceptions.",
  //   //     link: "/loans/disbursements",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Loan Account Servicing",
  //   //     description:
  //   //       "Manage post-disbursement balances, schedules, repayments, settlement, recovery, write-off and account audit trails.",
  //   //     link: "/loans/account-servicing",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Loan Restructuring",
  //   //     description:
  //   //       "Assess hardship, compare amended terms, govern approvals and activate controlled repayment-schedule versions.",
  //   //     link: "/loans/restructuring",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Intelligent Document Processing",
  //   //     description:
  //   //       "Classify loan documents, extract and validate application data, manage confidence exceptions and complete human review.",
  //   //     link: "/loans/document-processing",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "LMS Credit Scoring",
  //   //     description:
  //   //       "Traditional, alternative and hybrid scoring with provider integrations, policy rules, real-time decisions and mass rescoring.",
  //   //     link: "/loans/credit-scoring",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: loansIcon,
  //   //     option: "Loan Portfolio Reporting",
  //   //     description:
  //   //       "Enterprise portfolio intelligence for capital deployment, loan-type distribution, fees, performance, defaults and trend analysis.",
  //   //     link: "/loans/portfolio-reporting",
  //   //     show: USER_LOANS_UI_ENABLED,
  //   //   }
  //   //   ,
  //   //   {
  //   //     icon: collaborate,
  //   //     option: "Fees Module",
  //   //     description:
  //   //       "A comprehensive tool for managing fees",
  //   //     link: "/fees-setup",
  //   //     show: miniApps.feesModule || miniApps2.feesModule,
  //   //   },
  //   //   {
  //   //     icon: collaborate,
  //   //     option: "Fees Module New",
  //   //     description:
  //   //       "A comprehensive tool for managing fees",
  //   //     link: "/fees-setup-new",
  //   //     show: miniApps.feesModule || miniApps2.feesModule,
  //   //   }
  // ];

  const settingOptions = [
    ...(isDevEnv
    ? [
        {
          icon: dashboardIcon,
          option: "Dashboard",
          description:
            "Billing, security, audit log, and other account essentials",
          link: "/dashboard",
          show: miniApps.dashboard || miniApps2.dashboard,
        },
        {
          icon: programIcon,
          option: "Licenses",
          description:
            "Team management, user and organization fields, bulk actions, and tags",
          link: "/dashboard",
          show: miniApps.licenses || miniApps2.licenses,
        },
      ]
    : []),
    {
      icon: CRMIcon,
      option: "CRM",
      description:
        "Ways to connect with customers, from email and Talk to messaging and Flow Builder",
      link: "/crm",
      show: miniApps.crm || miniApps2.crm,
    },
    {
      icon: reportingIcon,
      option: "Reporting",
      description:
        "Managing how team members use Zendesk, from views and macros to Agent Workspace",
      link: "/reporting",
      show: miniApps.reporting || miniApps2.reporting,
    },
    ...(isDevEnv
    ? [
      {
        icon: marketingIcon,
        option: "Marketing",
        description: "Ticket fields, triggers, automations, and more",
        link: "/dashboard",
        show: miniApps.marketing || miniApps2.marketing,
      },
      {
        icon: batchIcon,
        option: "Batch Services",
        description:
          "Apps, APIs, targets, webhooks, and other ways to get data in and out of Zendesk",
        link: "/batch",
        show: miniApps.batchServices || miniApps2.batchServices,
      },
      // {
      //   icon: settingsIcon,
      //   option: "Settings",
      //   description: "Tips and answers to your questions about Admin Center",
      // },
      {
        icon: helpcenterIcon,
        option: "Business Rules",
        description: "Tips and answers to your questions about Admin Center",
        link: "/dashboard",
        show: miniApps.businessRules || miniApps2.businessRules,
      },
      {
        icon: seucrity,
        option: "Security",
        description: "Tips and answers to your questions about Admin Center",
        link: "/dashboard",
        show: miniApps.security || miniApps2.security,
      },
      {
        icon: settingsIcon,
        option: "Help Center",
        description: "Tips and answers to your questions about Admin Center",
        link: "/dashboard",
        show: miniApps.helpCenter || miniApps2.helpCenter,
      },
      {
        icon: marketPlace,
        option: "Marketplace",
        description:
          "Quickly manage modules in your CBS to extend new capabilities and services.",
        link: "/marketplace",
        show: miniApps.marketplace || miniApps2.marketplace,
      },
      {
        icon: collaborate,
        option: "Collaborate (CoFi) Lab",
        description:
          "Transforming the financial services landscape through Collaborative Finance (CoFi). Connect with forward-thinking businesses ready to collaborate.",
        link: "/cofilab",
        show: miniApps.collaborate || miniApps2.collaborate,
      },
      {
        icon: collaborate,
        option: "CS DEMO (Credit Scoring)",
        description:
          "A comprehensive tool for managing customer data, processing loan applications, and overseeing loan repayments",
        link: "/credit-scoring",
        show: miniApps.csDemo || miniApps2.csDemo,
      },
      {
        icon: collaborate,
        option: "Loan Setup",
        description:
          "A comprehensive tool for managing loans",
        link: "/loansetup",
        show: miniApps.loanSetup || miniApps2.loanSetup,
      },
      {
        icon: collaborate,
        option: "Loan Rule Setup",
        description:
          "Configure eligibility rules, interest rates, tenures, fees, and approval criteria for loan products",
        link: "/loan-rule-setup",
        show: miniApps.loanRuleSetup || miniApps2.loanRuleSetup,
      },
      {
        icon: collaborate,
        option: "Loan Reports",
        description:
          "A comprehensive tool for viewing loan reports",
        link: "/loanreports",
        show: miniApps.loanReports || miniApps2.loanReports,
      }
      ,
      {
        icon: loansIcon,
        option: "Early Warning Service",
        description:
          "Monitor portfolio credit scores, repayment risk, overdue exposure, ageing, and medium or high-risk loan accounts.",
        link: "/loans/early-warning",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Loan Enquiry Management",
        description:
          "Capture prospective borrower enquiries, run eligibility screening, manage borderline reviews, documents, quotations and screening policies.",
        link: "/loans/enquiries",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Loan Application Management",
        description:
          "Manage formal application cases from submission and underwriting through approval, sanction or rejection.",
        link: "/loans/applications",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Loan Disbursements",
        description:
          "Manage portfolio-wide disbursement approvals, release readiness, completed funding and operational exceptions.",
        link: "/loans/disbursements",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Loan Account Servicing",
        description:
          "Manage post-disbursement balances, schedules, repayments, settlement, recovery, write-off and account audit trails.",
        link: "/loans/account-servicing",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Loan Restructuring",
        description:
          "Assess hardship, compare amended terms, govern approvals and activate controlled repayment-schedule versions.",
        link: "/loans/restructuring",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Intelligent Document Processing",
        description:
          "Classify loan documents, extract and validate application data, manage confidence exceptions and complete human review.",
        link: "/loans/document-processing",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "LMS Credit Scoring",
        description:
          "Traditional, alternative and hybrid scoring with provider integrations, policy rules, real-time decisions and mass rescoring.",
        link: "/loans/credit-scoring",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: loansIcon,
        option: "Loan Portfolio Reporting",
        description:
          "Enterprise portfolio intelligence for capital deployment, loan-type distribution, fees, performance, defaults and trend analysis.",
        link: "/loans/portfolio-reporting",
        show: USER_LOANS_UI_ENABLED,
      }
      ,
      {
        icon: collaborate,
        option: "Fees Module",
        description:
          "A comprehensive tool for managing fees",
        link: "/fees-setup",
        show: miniApps.feesModule || miniApps2.feesModule,
      },
      {
        icon: collaborate,
        option: "Fees Module New",
        description:
          "A comprehensive tool for managing fees",
        link: "/fees-setup-new",
        show: miniApps.feesModule || miniApps2.feesModule,
      }
    ] : [])
  ];

  const lmsNames = new Set([
    "Loan Setup", "Loan Rule Setup", "Loan Enquiry Management",
    "Loan Application Management", "Intelligent Document Processing", "Loan Disbursements", "Loan Account Servicing", "Loan Restructuring", "LMS Credit Scoring", "Early Warning Service", "Loan Reports",
    "Loan Portfolio Reporting", "Fees Module", "Fees Module New",
  ]);
  const lmsOrder = [
    "Loan Setup", "Loan Rule Setup", "Fees Module", "Fees Module New",
    "Loan Enquiry Management", "Loan Application Management", "Intelligent Document Processing", "LMS Credit Scoring", "Loan Disbursements", "Loan Account Servicing", "Early Warning Service", "Loan Restructuring",
    "Early Warning Service", "Loan Reports", "Loan Portfolio Reporting",
  ];
  const extensionNames = new Set(["Marketplace", "Collaborate (CoFi) Lab", "CS DEMO (Credit Scoring)"]);
  const visibleOptions = settingOptions.filter((setting) => setting.show);
  const platformOptions = visibleOptions.filter((setting) => !lmsNames.has(setting.option) && !extensionNames.has(setting.option));
  const lmsOptions = visibleOptions.filter((setting) => lmsNames.has(setting.option)).sort((a,b)=>lmsOrder.indexOf(a.option)-lmsOrder.indexOf(b.option));
  const extensionOptions = visibleOptions.filter((setting) => extensionNames.has(setting.option));

  return (
    <Box className="page-container" sx={{mb: 3}}>
      <Box className="header-container">
        <Box className={`page-title`}>Admin Center</Box>
        <Box>
          Your home for settings to manage your account, team, and more.
        </Box>
      </Box>

      <Box className="settings-center-container">
        <SettingsSection title="Platform & Administration" description="Core administration, customer management, reporting and operational services." options={platformOptions}/>
        {lmsOptions.length > 0 && <SettingsSection title="LMS Module" description="Loan origination, application governance, portfolio monitoring and lending configuration." options={lmsOptions} featured/>}
        {extensionOptions.length > 0 && <SettingsSection title="Extensions & Labs" description="Optional capabilities, demonstrations and collaborative services." options={extensionOptions}/>}
      </Box>
    </Box>
  );
}

function SettingsSection({ title, description, options, featured = false }) {
  if (!options.length) return null;
  return <Box className={`settings-section ${featured ? "is-featured" : ""}`}>
    <Box className="settings-section-heading">
      <Typography component="h2">{title}</Typography>
      <Typography>{description}</Typography>
    </Box>
    <Grid container spacing={3}>
      {options.map((setting) => <Grid item xs={12} sm={6} md={4} lg={3} key={setting.option}>
        <Box className="settings-card">
          <Link to={setting.link}>
            <Box className="settings-card-title-container d-flex align-items-center">
              <img src={setting.icon} alt="" loading="lazy" />
              <Typography>{setting.option}</Typography>
            </Box>
            <Box className="settings-card-body">{setting.description}</Box>
            <Box className="settings-card-link">Open {setting.option}</Box>
          </Link>
        </Box>
      </Grid>)}
    </Grid>
  </Box>;
}

export default Settings;
